
export default [
    {
        class: 'col-xs-12 col-sm-12 col-md-12 col-lg-12 col-xl-12',
        type: 'group',
        icon: 'fa fa-arrow-circle-right',
        label: 'Informações da Consulta',
    },
    {
        class: 'col-xs-12 col-sm-12 col-md-12 col-lg-12 col-xl-7',
        type: 'text',
        field: 'funcionario',
        label: 'Trabalhador (a)',
        rules: ['required']
    },
    {
        class: 'col-xs-12 col-sm-12 col-md-12 col-lg-12 col-xl-5',
        type: 'text',
        field: 'id_fdt',
        label: 'Frente de Trabalho',
        rules: ['required']
    },
    {
        class: 'col-xs-12 col-sm-12 col-md-12 col-lg-12 col-xl-5',
        type: 'text',
        field: 'id_funcao',
        label: 'Função',
        rules: ['required']
    },
    {
        class: 'col-xs-12 col-sm-12 col-md-12 col-lg-12 col-xl-4',
        type: 'text',
        field: 'id_ghe',
        label: 'GHE (Setor)',
        rules: ['required']
    },
    {
        class: 'col-xs-12 col-sm-12 col-md-12 col-lg-12 col-xl-3',
        type: 'text',
        field: 'data_age',
        label: 'Data do Agendamento da Consulta',
        rules: ['required'],
    },
    {
        class: 'col-xs-12 col-sm-12 col-md-12 col-lg-12 col-xl-12',
        type: 'text',
        tipo: 46,
        field: 'id_tipo_aso',
        label: 'Tipo de Consulta',
        rules: ['required']
    },
    {
        class: 'col-xs-12 col-sm-12 col-md-12 col-lg-12 col-xl-12',
        type: 'textarea',
        field: 'obs',
        label: 'Observações',
        rules: ['required']
    },
    {
        class: 'col-xs-12 col-sm-12 col-md-12 col-lg-12 col-xl-12',
        type: 'group',
        icon: 'fa fa-arrow-circle-right',
        label: 'Selecione uma Ação',
    },
];



// WEBPACK FOOTER //
// ./src/components/apps/credenciada/consulta/_form/consulta-editar.js